module.exports = __webpack_public_path__ + "static/img/head-bg.3f0ff4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head-bg.png
// module id = 4Dyn
// module chunks = 0